import { useEffect, useState } from 'react';

export type TReactiveVar<T> = {
  // eslint-disable-next-line no-unused-vars
  (newValue?: T): T;
  // eslint-disable-next-line no-unused-vars
  subscribe: (fn: (val: T) => void) => () => void;
};

export function createReactiveVar<T>(defaultValue: T): TReactiveVar<T> {
  // eslint-disable-next-line no-unused-vars
  type TCallback = (val: T) => void;
  const callbacks: TCallback[] = [];

  const res: TReactiveVar<T> = (newValue) => {
    if (newValue !== undefined) {
      defaultValue = newValue;

      callbacks.forEach((cb) => cb(defaultValue));
    }

    return defaultValue;
  };

  res.subscribe = (cb) => {
    callbacks.push(cb);

    return () => {
      const index = callbacks.indexOf(cb);

      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  };

  return res;
}

export function useReactiveVar<T>(reactiveVar: TReactiveVar<T>): T {
  const [value, setValue] = useState(reactiveVar());

  useEffect(() => reactiveVar.subscribe(setValue), [reactiveVar]);

  return value;
}
